import React from 'react'

const CompletarConfiguracion = ({configuracion}) => {
   return (
      <div className="flex min-h-screen w-full items-center justify-center bg-gray-100 p-4">
        <div className="w-full max-w-2xl rounded-lg bg-white p-8 text-center shadow-xl border border-red-200">
          
          {/* Encabezado */}
          <h1 className="text-2xl font-bold text-red-600">
            ⚠️ Configuración Incompleta
          </h1>
          <p className="mt-2 text-gray-600">
            Para que el sistema funcione correctamente, por favor revisa y completa los siguientes campos requeridos:
          </p>
          
          {/* Lista de Elementos Faltantes */}
          <div className="mt-6">
            <ul className="list-disc list-inside space-y-2 text-left text-gray-700">
              {configuracion.elementosFaltantes.map((error, index) => (
                <li key={index} className="pl-2">
                  {error}
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>
    );
}

export default CompletarConfiguracion
